import { Grid } from "@mui/material";
import { librarySelectedTab, setInnCode } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { resetAllModifiedFilters } from "components/common/Filters/GlobalFilters.slice";
import PageTitle from "components/common/PageTitle";
import Tabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { libraryTabDetails } from "./TabsConfig";
import "./index.scss";

const Library = () => {
  const dispatch = useAppDispatch();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedTab = useAppSelector((state) => state.app.selectedTab);
  const { isMobileScreen } = useContext(ThemeContext);
  const { isCorp } = useAppSelector((state) => state.app.loggedInUserDetails);

  const handleTabSelection = (x: number) => {
    dispatch(librarySelectedTab(x));
  };

  const handleOnChange = (value: string) => {
    dispatch(librarySelectedTab(0));
    dispatch(setInnCode(value));
    localStorage.setItem("innCode", value);
    dispatch(resetAllModifiedFilters());
  };

  return (
    <>
      <Grid
        sx={{ backgroundColor: tokens.Background.General.Secondary }}
        display={"flex"}
        alignItems="center"
        justifyContent={"space-between"}
        flexDirection={isMobileScreen ? "column" : "row"}
      >
        <PageTitle label={"Library"} />
        <Grid
          item
          xs={12}
          display={"flex"}
          alignItems="center"
          justifyContent={"center"}
          sx={{ textAlign: "center", gap: "8px" }}
        >
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Exploring plans for
          </Typography>

          <InncodeDropDown
            parentBoxWidth="100px"
            backgroundColor={tokens.Background.General.Color}
            width={isMobileScreen ? "170px" : "284px"}
            height="24px"
            color={tokens.Text.General.Color}
            isCorp={isCorp}
            value={innCode || "undefined"}
            onChange={handleOnChange}
          />
        </Grid>
      </Grid>
      <Tabs
        shouldAppendTabParam
        alignItems="left"
        tabDetails={libraryTabDetails}
        defaultTab={selectedTab || 0}
        selectedTab={handleTabSelection}
      />
    </>
  );
};

export default Library;
